import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable()
export class ValidationService {

  constructor() { }

  arePasswordsEqual(group: FormGroup) {
    if (group.controls['password'].value !== group.controls['passwordVerify'].value) {
      group.controls['passwordVerify'].setErrors({ areEqual: false });
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/providers/validation.service.ts